module.exports = __webpack_public_path__ + "img/environment-circle.bdb289cc.png";